import { deployments, resolveEnvironment } from '@cascade/core/deployments';
import type { TServiceWorkerOptions } from '@cascade/react-dom/hooks';
import type { TObservabilityOptions } from '@cascade/react-dom/observability';

const ENVIRONMENT = resolveEnvironment(import.meta.env.VITE_ENVIRONMENT);

export const IS_PRODUCTION = ENVIRONMENT === 'production';

export const deployment = deployments[ENVIRONMENT];

export const observability: TObservabilityOptions = {
  isEnabled: IS_PRODUCTION,
  environment: ENVIRONMENT,
  release: import.meta.env.VITE_RELEASE || undefined,
  fullStoryOrgId: 'o-1ZP9RM-na1',
  logRocketAppId: 'qxddwk/cascade',
  googleTagManagerId: 'GTM-MKMMKF9N',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || undefined,
};

export const serviceWorker: TServiceWorkerOptions = {
  isEnabled: import.meta.env.PROD,
  url: '/sw.js',
};

export const NPS_WORKSPACE_ID = '687929b00cc1d4d98d728497';

export const NPS_SURVEY_ID = '4cvD9N';

export const PROJECT_ID_PARAM = 'project_id';

export const SUMMARY_PARAM = 'summary';
